import React from 'react';
import { Routes, Route } from 'react-router-dom';
import '../src/components/@common.blocks/Text/index';

import './index.css';

import PageHome from './components/@pages/PageHome/PageHome';
import PageKontrollery from './components/@pages/PageKontrollery/PageKontrollery';
import PageUslugi from './components/@pages/PageUslugi/PageUslugi';
import PageFillTheForm from './components/@pages/PageFillTheForm/PageFillTheForm';
import PageDostavka from './components/@pages/PageDostavka/PageDostavka';
import PageOKompanuu from './components/@pages/PageOKompanuu/PageOKompanuu';
import PageOborudovanie from './components/@pages/PageOborudovanie/PageOborudovanie';
import Layout from './components/Layout';

function App() {
  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<PageHome />}></Route>
          <Route path="equipping" element={<PageOborudovanie />} />
          <Route path="controllers" element={<PageKontrollery />} />
          <Route path="services" element={<PageUslugi />} />
          <Route path="fill_the_form" element={<PageFillTheForm />} />
          <Route path="dostavka" element={<PageDostavka />} />
          <Route path="okompanuu" element={<PageOKompanuu />} />
        </Routes>
      </Layout>
    </>
  );
}

export default App;
